<template>
    <Tag :severity="type" :icon="icon" :rounded="rounded">
        <slot>标签</slot>
    </Tag>
</template>

<script>
import Tag from 'primevue/tag';

export default {
    name: 'tw-tag',
    components: {
        Tag
    },
    props: {
        type: String,
        icon: String,
        rounded: Boolean
    }
}
</script>
